<div class="mat-elevation-z0">
  <!-- Desktop Table (visible only on desktop) -->
  <div class="responsive-table" *ngIf="!isMobile">
    <table mat-table class="table-striped mb--sm" *ngIf="dataSource" [dataSource]="tableData">
      <ng-container *ngFor="let column of columns; let i = index" [matColumnDef]="column">
        <th mat-header-cell *matHeaderCellDef [ngClass]="{ 'align-center': column === 'actions' }">
          @if(i === 0 && this.withSelection){
          <mat-checkbox
            (change)="$event ? toggleAllRows() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
            [aria-label]="checkboxLabel()"
          >
          </mat-checkbox>
          }@else {
          {{ this.displayedColumns.get(column)?.label || column | translate }}
          }
        </th>

        <td mat-cell *matCellDef="let element" [ngClass]="{ 'align-center': column === 'actions' }">
          @if(i === 0 && this.withSelection){
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? onRowClick(element) : null"
            [checked]="selection.isSelected(element)"
            [aria-label]="checkboxLabel(element)"
          >
          </mat-checkbox>
        }@else if(column === 'actions'){
          <div class="table-actions-container">
            <div
              *ngFor="let action of getRowActions(actions, element)"
              class="table-actions-icons p--sm"
              (click)="onActionClick($event, action.tableAction, element)"
            >
              <span
                class="icon-{{ action.icon }} color--{{ action.iconColor }}"
                [attr.aria-label]="action.name | translate"
                aria-hidden="false"
              ></span>
            </div>
          </div>
        } @else {
          <ng-container
            *ngTemplateOutlet="columnTemplate; context: { $implicit: element, column: column }"
          ></ng-container>
        }
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr mat-row *matRowDef="let row; columns: columns" (click)="onRowClick(row)"></tr>
    </table>
  </div>

  <!-- Mobile List (visible only on mobile) -->
  <div class="mobile-list mb--md" *ngIf="isMobile">
    <div class="list-container">
      <div
        class="list-row"
        *ngFor="let element of tableData | async"
        [ngClass]="{ 'selected': selection.isSelected(element), 'selectable': withSelection }"
        (click)="onRowClick(element)"
      >
        @if(withSelection) {
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? onRowClick(element) : null"
            [checked]="selection.isSelected(element)"
            [aria-label]="checkboxLabel(element)"
          ></mat-checkbox>
        }

        <div class="content">
          <div class="text">
            <div 
              class="title bold color--navy"
              [ngClass]="{ 'status-line': isStatusColumn(getMobileColumns()[0]) }"
            >
              <ng-container
                *ngTemplateOutlet="columnTemplate; context: { $implicit: element, column: getMobileColumns()[0] }"
              ></ng-container>
            </div>
            <div 
              class="meta text-small color--dark-grey" 
              *ngFor="let column of getMobileColumns().slice(1)" 
              [ngClass]="{ 'status-line': isStatusColumn(column), 'clickable-line': clickableColumns.has(column) }"
              (click)="onColumnClick(column, element)"
            >
              <ng-container
                *ngTemplateOutlet="columnTemplate; context: { $implicit: element, column: column }"
              ></ng-container>
            </div>
          </div>

          @if(actions.length) {
            <div class="actions">
              @if(getRowActions(actions, element).length > 1) {
                <button
                  mat-fab
                  class="fab-trigger"
                  type="button"
                  (click)="$event.stopPropagation()"
                  [matMenuTriggerFor]="rowActionsMenu"
                  #rowActionsTrigger="matMenuTrigger"
                >
                  <span 
                    class="icon-plus" 
                    [@fabTriggerRotate]="rowActionsTrigger.menuOpen ? 'open' : 'closed'">
                  </span>
                </button>
                <mat-menu #rowActionsMenu="matMenu" class="fab-menu-panel" xPosition="before" yPosition="above">
                  <button mat-menu-item class="fab-menu-item"
                    *ngFor="let action of getRowActions(actions, element)"
                    (click)="onActionClick($event, action.tableAction, element); rowActionsTrigger.closeMenu()"
                    [ngClass]="'color--' + action.iconColor"
                    [style.border-color]="'var(--ppu-color-' + action.iconColor + ')'"><span class="icon-{{ action.icon }} color--{{ action.iconColor }}"></span>
                    <span class="label color--{{ action.iconColor }}">{{ action.name | translate }}</span>
                  </button>
                </mat-menu>
              } @else {
                <button
                  class="pill-action"
                  type="button"
                  *ngFor="let action of getRowActions(actions, element)"
                  (click)="onActionClick($event, action.tableAction, element)"
                  [ngClass]="'color--' + action.iconColor"
                >
                  <span class="icon icon-{{ action.icon }} color--{{ action.iconColor }}"></span>
                </button>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  
  <mat-paginator
    [ngClass]="{'hidden': !withPagination}"
    (page)="onPageChange($event)"
    [length]="resultsLength"
    [pageSizeOptions]="pageSizeOptions"
    [pageSize]="pageSize"
    [pageIndex]="currentPage"
    [showFirstLastButtons]="true"
    aria-label="Select page"
  >
  </mat-paginator>
</div>

<!-- ng-templates for repeated logic -->

<!-- Status Cell Template -->
<ng-template #statusTemplate let-element let-column="column">
  @if(statusClickable) {  
    <button
      mat-button
      [ngClass]="getStatusClass(element[column])"
      (click)="$event.stopPropagation(); onStatusClick(element)"
    >
      {{ getMappedStatus(element[column]) | translate }}
    </button>
  }
  @else {
    <div
      mat-button
      class="mat-mdc-button mdc-button non-clickable"
      [ngClass]="getStatusClass(element[column])"
    >
      <span class="mdc-button__label">
        {{ getMappedStatus(element[column]) | translate }}
      </span>
    </div>
  }
</ng-template>

<!-- Generic Column Cell Template -->
<ng-template #columnTemplate let-element let-column="column">
  @switch (true) {
    @case (isStatusColumn(column)) {
      <ng-container 
        *ngTemplateOutlet="statusTemplate; context: { $implicit: element, column: column }"
      ></ng-container>
    }
    @case (clickableColumns.has(column)) {
      <a
        class="table-link"
        (click)="$event.stopPropagation(); onColumnClick(column, element)"
      >
        {{ element[column] | customFormat: displayedColumns.get(column)?.format }}
      </a>
    }
    @case (hasTooltip(column, element)) {
      {{ element[column] | customFormat: displayedColumns.get(column)?.format }}
      <span
        class="ml--xxs"
        [matTooltip]="displayedColumns.get(column)?.tooltip! | translate"
        [matTooltipPosition]="'above'"
      >
        <i class="icon-box-return color--electric-blue"></i>
      </span>
    }
    @default {
      {{ element[column] | customFormat: displayedColumns.get(column)?.format }}
    }
  }
</ng-template>